export const SET_PRICE = 'price//SET_PRICE';
export const SET_RATES = 'price//SET_RATES';
export const SET_ERROR = 'price//SET_ERROR';

export function setPrice(payload) {
  return {
    type: SET_PRICE,
    payload
  };
}

export function setRates(payload) {
  return {
    type: SET_RATES,
    payload
  };
}

export function setError(message) {
  return {
    type: SET_ERROR,
    message
  };
}

const initialState = {
  rates: [],
  grossLoanAmount: undefined,
  vatAmount: 0,
  error: undefined
};

const errorState = {
  rates: [],
  grossLoanAmount: undefined,
  vatAmount: 0,
  error:
    'Das System steht zurzeit nicht zur Verfügung. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_PRICE: {
      const { duration, mileage } = action.payload;
      if (state.rates && state.rates.length > 0) {
        if (typeof findPrice(state.rates, duration, mileage) !== 'undefined') {
          const price = findPrice(state.rates, duration, mileage).prices[0];

          const { grossLoanAmount, vatAmount } = getPriceGrossAmountAndVat(price);
          return {
            ...state,
            grossLoanAmount,
            vatAmount
          };
        }
        return errorState;
      }

      return {
        ...state
      };
    }
    case SET_RATES: {
      const { duration, mileage, rates } = action.payload;

      if (rates && rates.length > 0) {
        if (typeof findPrice(rates, duration, mileage) !== 'undefined') {
          const price = findPrice(rates, duration, mileage).prices[0];

          const { grossLoanAmount, vatAmount } = getPriceGrossAmountAndVat(price);
          return {
            ...state,
            rates,
            grossLoanAmount,
            vatAmount,
            error: undefined
          };
        }
        return errorState;
      }

      return {
        ...state,
        grossLoanAmount: '-,--',
        error: 'Es konnten keine Preise ermittelt werden.'
      };
    }

    case SET_ERROR: {
      return {
        ...state,
        grossLoanAmount: '-,--',
        error: action.message
      };
    }

    default:
      return state;
  }
}

export const findPrice = (rates, duration, mileage) =>
  rates.find(rate => duration === rate.duration && mileage === rate.yearlyMileage);

export const getPriceGrossAmountAndVat = price => {
  if (price.discount) {
    return {
      grossLoanAmount: price.grossPromoAmount,
      vatAmount: price.vatPromoAmount
    };
  }

  return {
    grossLoanAmount: price.grossLoanAmount,
    vatAmount: price.vatAmount
  };
};
